/**
 * @generated SignedSource<<3cba231fa2c0f0a9f72933feea5cc470>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetitionJuryRemoveMutation$variables = {
  competitionId: string;
  connections: ReadonlyArray<string>;
  entityId: string;
};
export type CompetitionJuryRemoveMutation$data = {
  readonly removeCompetitionJury: {
    readonly displayName: string;
    readonly id: string;
  };
};
export type CompetitionJuryRemoveMutation = {
  response: CompetitionJuryRemoveMutation$data;
  variables: CompetitionJuryRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "competitionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "competitionId",
    "variableName": "competitionId"
  },
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "entityId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionJuryRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeCompetitionJury",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionJuryRemoveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "removeCompetitionJury",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2ea9c394d5a4d5d984d81413460c8b5",
    "id": null,
    "metadata": {},
    "name": "CompetitionJuryRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionJuryRemoveMutation(\n  $competitionId: ID!\n  $entityId: ID!\n) {\n  removeCompetitionJury(competitionId: $competitionId, entityId: $entityId) {\n    __typename\n    id\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "58fd7fded72c521c9c3bb7e170dde4f3";

export default node;
